// libs
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

// Component
import Card from '../../../cards/card/Card';
import LinedTitle from '../../../tools/linedTitle/LinedTitle';

// Styles
import './styles.scss';

// Props and Context
const propTypes = {
  slide: PropTypes.object.isRequired,
};
const defaultProps = {};
const contextType = {};

function ExploreSlide(props) {
  const {
    slide: {
      title,
      frontContents,
      image = null,
      background_color: backgroundColorCode,
      text_color: textColor,
    },
  } = props;
  const sliderSettings = {
    slidesToShow: 2,
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 608,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section
      className={`explore-slide explore-slide--${textColor} section`}
      style={{ backgroundColor: backgroundColorCode }}
    >
      <div
        className="explore-slide__background"
        style={{ backgroundImage: image ? `url(${image.large})` : '' }}
      />
      <div className="explore-slide__content">
        {title && <LinedTitle title={title} />}
        {frontContents &&
        <div className="explore-slide__cards">
          <Slider {...sliderSettings}>
            {frontContents.map(frontContent =>
              <Card {...frontContent} key={`slide_explore_${frontContent.slug}`} />,
            )}
          </Slider>
        </div>
        }
      </div>
    </section>
  );
}

ExploreSlide.propTypes = propTypes;
ExploreSlide.defaultProps = defaultProps;
ExploreSlide.contextTypes = contextType;

export default ExploreSlide;



// WEBPACK FOOTER //
// ./src/app/components/pages/landing/explore/ExploreSlide.js